const StringConstants = {
  BRANDS: {
    UNFORMATTED: {
      zillow: 'zillow',
      trulia: 'trulia',
      hotpads: 'hotpads',
      default: 'zillow',
    },
    FORMATTED: {
      zillow: 'Zillow',
      trulia: 'Trulia',
      hotpads: 'HotPads',
      zrm: 'Zillow Rental Manager',
    },
  },
  LINKS: {
    HOME_PAGE: {
      zillow: 'https://zillow.com/',
      trulia: 'https://trulia.com/',
      hotpads: 'https://hotpads.com/',
    },
    MARKETING_PAGE: {
      ZRM_PAYMENTS: 'https://www.zillow.com/z/rental-manager/collect-rent-online/',
    },
    RENTAL_PROTECTION: {
      SUPPORT_EMAIL: 'rentalprotection@zillowinsuranceservices.com',
      FAILED_PAYMENT_FAQ: 'https://www.zillow.help/article/discontinuing-rental-protection-zd39604170235155',
      MANAGE_POLICY_PAGE: (listingAlias, policyId?) =>
        `/rental-manager/rental-protection/properties/${listingAlias}/managePolicies${
          policyId ? `/policy-${policyId}` : ''
        }`,
    },
    FAQ_PAGE: {
      zillow: 'https://zillow.zendesk.com/hc/en-us/sections/360000067847-Online-Rent-Payments',
      trulia: 'https://support.trulia.com/hc/en-us/sections/201041998',
      hotpads: 'https://help.hotpads.com/hc/en-us/sections/360000041103-Online-Rent-Payments',
      zrm: 'https://www.zillow.help/categories/Renter_Landlord_Property_Manager%2FLandlord_Property_Manager%2FCollect_Payments',
    },
    HOW_LONG_FAQ_PAGE: {
      zillow:
        'https://zillow.zendesk.com/hc/en-us/articles/' +
        '360000603708-How-long-does-it-take-for-my-landlord-to-receive-my-rent-',
      trulia:
        'https://support.trulia.com/hc/en-us/articles/' +
        '360000605128-Rent-Payments-How-long-does-it-take-for-my-landlord-to-receive-my-rent-',
      hotpads:
        'https://help.hotpads.com/hc/en-us/articles/' +
        '360000336403-How-long-does-it-take-for-my-landlord-to-receive-my-rent-',
    },
    RENT_AMOUNT_CHANGE_FAQ: {
      LANDLORD:
        'https://www.zillow.help/article/how-does-my-renter-accept-the-new-rent-amount-change-zd30234436923411?networkDataCategoryId=9cnHu000000CagAIAS',
    },
    SUPPORT_PAGE: {
      LANDLORD: 'https://zgrentals.zendesk.com/hc/en-us/requests/new?ticket_form_id=360000053487',
      RENTER: 'https://zgrentals.zendesk.com/hc/en-us/requests/new?ticket_form_id=360000016927',
    },
    SUPPORT_EMAIL: {
      zillow: 'rentpayments@zillow.com',
      trulia: 'rentpayments@trulia.com',
      hotpads: 'rentpayments@hotpads.com',
    },
    LEARN_ABOUT_PAYMENT_PLAN_FAQ: {
      LANDLORD: 'https://www.zillow.help/article/payment-set-up-zd32876589716627',
    },
    PREPARE_FOR_MISSED_RENT_CLAIM: {
      LANDLORD: 'https://www.zillow.help/article/discontinuing-rental-protection-zd39604170235155',
    },
    PAYMENT_PLAN_TEMPLATE: 'https://filenet.hotpads.com/Payment%20Plan%20-%20Editable.docx',
    GO_TO_LEASES: (propertyId) => `/rental-manager/leasing/property/${propertyId}`,
    TAX_VERIFICATION_LEARN_MORE: {
      LANDLORD: 'https://www.irs.gov/businesses/understanding-your-form-1099-k',
    },
  },
  API: {
    VERBS: {
      GET: 'get',
      PUT: 'put',
      POST: 'post',
      DELETE: 'delete',
    },
    RENTAL_MANAGER: {
      PROXY: '/rental-manager/payments/proxy',
      UPLOAD_PROXY: '/rental-manager/api',
      API: '/rental-manager-api/api/v1/users',
      PROPERTIES_API: '/rental-manager-api/api/v1/properties',
      API_V2: '/rental-manager-api/api/v2/users',
      API_V3: '/rental-manager-api/api/v3/users',
    },
    RENTER_HUB: {
      PROXY: '/renter-hub/payments/proxy',
      API: '/renter-hub-api/api/v1/users',
      API_V2: '/renter-hub-api/api/v2/users',
    },
    RENT_PAYMENT: '/rentPayment',
    RENTAL_PROTECTION: '/properties/rentGuarantee',
    USER_PROFILE: '/profile',
    ADDRESSES: '/addresses',
    RENT_CREDIT_REPORT: '/rentCreditReport',
  },
  ROUTING: {
    NEXT: 'next',
    PREV: 'prev',
    ALLOW_PARAMS_REGEX: '([?].*)?([&].*)?',
    MARKETING_PATH: {
      PAYMENTS: 'payments',
      APPLICATIONS: 'applications',
    },
  },
  APP_SOURCES: ['ipad', 'iphone', 'android'],
};

export default StringConstants;
